import { ActionType, ProColumns } from '@ant-design/pro-components';
import { DatePicker, Form, message } from 'antd';
import BoxContainer from 'base/ui/components/BoxContainer';
import CustomButton from 'base/ui/components/Button';
import CustomProTable from 'base/ui/components/CustomTable';
import { CheckStatus, CloseStatus } from 'base/ui/components/Icons';
import dayjs from 'dayjs';
import usePartialState from 'hooks/usePartialState';
import { SearchForm, SearchItem } from 'pages/Components/SearchBox';
import React, { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { RemindUpdateModel } from 'services/Masterdata/warrantyRemind_services';
import { warrantyRemindPresenter, warrantyRemindStore } from 'stores/root_store';
import { DATE_FORMAT_POST } from 'utils/constants';

type Props = {
  productIds: string[],
  companyCode: string,
  handleClose: () => void,
  warrantyReminderId: string | null
}

const ReminderModal = ({ productIds, companyCode, handleClose, warrantyReminderId }: Props) => {
  const [form] = Form.useForm();

  //=====================================CHUYỂN NGÔN NGỮ=====================================//
  const { t } = useTranslation();

  const [loading, setLoading] = usePartialState({
    btn: false,
    cal: false
  })

  const defaultColumn: ProColumns<RemindUpdateModel>[] = [
    {
      title: 'STT',
      dataIndex: 'stt',
      fixed: true,
      width: 50,
      align: 'center',
    },
    {
      title: 'Mã đăng kí',
      dataIndex: 'registerCode',
      width: 100,
    },
    {
      title: 'Khách hàng',
      dataIndex: 'profileName',
      width: 300,
    },
    {
      title: 'Mã SAP',
      dataIndex: 'sapCode',
      align: 'center',
      width: 100,
    },
    {
      title: 'Tên sản phẩm',
      dataIndex: 'productName',
      width: 300,
    },
    {
      title: 'Tên bảo hành',
      dataIndex: 'warrantyName',
      width: 300,
    },
    {
      title: 'Ngày bắt đầu',
      dataIndex: 'startDate',
      width: 150,
      valueType: 'dateTime',
      fieldProps: {
        format: 'DD/MM/YYYY HH:mm:ss',
      },
      onCell: (_, index) => ({
        className: 'text-center',
      }),
    },
    {
      title: 'Bảo hành đến ngày',
      dataIndex: 'warrantyDate',
      width: 150,
      valueType: 'dateTime',
      fieldProps: {
        format: 'DD/MM/YYYY HH:mm:ss',
      },
      onCell: (_, index) => ({
        className: 'text-center',
      }),
    },
    {
      title: 'Trạng thái sử dụng',
      dataIndex: 'actived',
      render: (_, record) =>
        record.actived ? (
          <CheckStatus width="14" className="!fill-[#0052cc] block mx-auto" />
        ) : (
          <CloseStatus width="14" className="!fill-red-500 block mx-auto" />
        ),
    },
  ];


  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const [ids, setIds] = useState<any[]>([]);
  const [listProduct, setListProduct] = useState<RemindUpdateModel[]>([]);
  const tableRef = useRef<ActionType>();

  const handleSearch = async (values: any) => {
    setLoading({ btn: true })
    await warrantyRemindPresenter.reminderUpdateCalendar(warrantyRemindStore, {
      fromTime: dayjs(values.fromTime).format(DATE_FORMAT_POST),
      toTime: dayjs(values.toTime).format(DATE_FORMAT_POST),
      productList: productIds ? productIds : undefined,
      // companyCode: companyCode
    })

    if (warrantyRemindStore.dataUpdateRemind.isSuccess) {
      setListProduct(warrantyRemindStore.dataUpdateRemind.data)
    }
    setLoading({ btn: false })
  }


  // select row
  const onSelectChange = (newSelectedRowKeys: React.Key[], selectRows: RemindUpdateModel[]) => {
    setSelectedRowKeys(newSelectedRowKeys);
    setIds(selectRows.map(item => item.productWarrantyId))
  };

  const handleCaculator = async () => {

    setLoading({ cal: true })
    if (ids.length) {

      await warrantyRemindPresenter.caculateCalendar(warrantyRemindStore, {
        productWarrantyList: ids,
        remindConfigId: warrantyReminderId
      })
      if (warrantyRemindStore.caculate.isSuccess) {
        message.success(warrantyRemindStore.caculate.message)
        handleClose()
      }
    } else {
      message.warning('Vui lòng chọn dòng');
    }
    setLoading({ cal: false })
  }

  return (
    <BoxContainer fullHeight>
      <SearchForm
        form={form}
        layout="vertical"
        column='col-3'
        onFinish={(values) => {
          handleSearch(values)
        }}
      >
        <SearchItem
          name={"fromTime"}
          label={'Từ ngày'}
          rules={[
            { required: true, message: 'Vui lòng chọn' }
          ]}
        >
          <DatePicker format={'DD/MM/YYYY'} className='!w-full' />
        </SearchItem>
        <SearchItem
          name={"toTime"}
          label={'Đến ngày'}
          rules={[
            { required: true, message: 'Vui lòng chọn' }
          ]}
        >
          <DatePicker format={'DD/MM/YYYY'} className='!w-full' />
        </SearchItem>

        <div className='flex items-end'>
          <CustomButton
            loading={loading.btn}
            onClick={() => {
              form.submit()
            }}
            type='primary'>
            Tìm kiếm
          </CustomButton>
        </div>

      </SearchForm>

      <CustomProTable
        columns={defaultColumn}
        size="small"
        dataSource={listProduct}
        search={false}
        options={false}
        actionRef={tableRef}
        tableAlertRender={false}
        scroll={{
          x: 1600,
          y: 200
        }}
        rowSelection={{
          selectedRowKeys,
          onChange: onSelectChange,
        }}
        pagination={false}
        rowKey="stt"
      />

      <div className='flex justify-end items-end mt-4 gap-4'>
        <CustomButton loading={loading.cal} onClick={handleCaculator} type='primary'>Cập nhật lịch nhắc</CustomButton>
      </div>

    </BoxContainer>
  )
}

export default ReminderModal